import { withI18n } from 'react-i18next';
import DateSingle from './DateSingle';

export const pureComponent = DateSingle;
export default withI18n()(DateSingle);
